import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  overflow: hidden;
`;

export const CardOrder = styled.div`
  background-color: white;
  padding: 2rem 1.5rem;
  margin: 1rem auto;
  border-radius: 0.5rem;
  max-width: 762px;

  @media (max-width: 700px) {
    margin: 1rem 0.8rem 2rem 0.8rem;
    padding: 2rem 0rem;
    height: auto;
    min-height: 85vh;
  }

  @media (max-width: 280px) {
    margin: 1rem 0.3rem 1rem 0.3rem;
    padding: 1rem 0rem;
    height: auto;
    min-height: 85vh;
  }

  @media (max-width: 700px) and (min-height: 795px) {
    min-height: 90vh;
  }

  @media (min-width: 768px) {
    border-radius: 0.5rem;
  }
`;

export const MainContainer = styled.div`
  margin: 0 1.5rem;

  @media(min-width: 770px) {
    margin: -1rem 1.5rem;
  }

  @media(max-width: 280px) {
    margin: 0rem 0.5rem;
  }
`;
